module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z",
    on: {
      "changeInterval": _vm.changeInterval
    }
  }, [_c('vue-slider', {
    ref: "vueslider",
    attrs: {
      "min": 0,
      "max": _vm.stepsCount,
      "value": _vm.selectedIndexes,
      "lazy": true,
      "piecewise": true,
      "formatter": _vm.formatLabel,
      "tooltip-dir": "right",
      "height": 2,
      "dot-size": 34
    },
    on: {
      "callback": _vm.onCallback
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bffefd4c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/interval-slider/IntervalSlider.vue
// module id = 961
// module chunks = 1